(function ($) {
    $(document).ready(function () {
        openCloseTag();
        doGalleryHub();
    });


    function openCloseTag() {
        if ($('.open_tag_info').length > 0) {
            $('.open_tag_info').each(function () {
                $(this).on("click", function () {
                    var $id_to_open = $(this).data('open');
                    if ($(".container-bottom-detailed-preview[data-info='" + $id_to_open + "']").length > 0) {
                        if (!$(this).hasClass('tag_opened')) {
                            $(".container-bottom-detailed-preview[data-info='" + $id_to_open + "']").addClass('clicked').fadeIn();
                            setTimeout(function () {
                                $(".open_tag_info[data-open='" + $id_to_open + "']").text(less_amenities)
                            }, 300)

                        } else {
                            $(".container-bottom-detailed-preview[data-info='" + $id_to_open + "']").fadeOut().removeClass('clicked');
                            setTimeout(function () {
                                $(".open_tag_info[data-open='" + $id_to_open + "']").text(view_amenities)
                            }, 300)
                        }
                        $(".open_tag_info[data-open='" + $id_to_open + "']").toggleClass('tag_opened')
                    }
                });
            });
        }
    }


    function doGalleryHub() {
        var wraps = $('.detailed_preview .container-img-detailed-preview');
        if (wraps.length > 0) {
            customPagingVariable = function (slider, i) {
                // var thumb = $(slider.$slides[i]).data();
                i = i + 1;
                if (i.toString().length < 2) {
                    i = "0" + i;
                }
                return '<a class="dot">' + i + '</a>';
            }

            //slideshow setup
            wraps.each(function () {
                var wrap = $(this);

                var wrapSingle = wrap.find('.slider_inner_wrap')
                wrapSingle.on("init", function () {
                    lazyLoadInstance.update();
                });
                wrapSingle.slick({
                    dots: true,
                    rows: 0,
                    fade: true,
                    autoplay: false,
                    arrows: true,
                    nextArrow: accor_arrow_next,
                    prevArrow: accor_arrow_prev,
                    appendDots: wrap.find('.pager'),
                    appendArrows: wrap.find('.container_buttons_slider'),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    customPaging: customPagingVariable,
                    rtl: $('html').attr('dir') == 'rtl'
                });
            })
        }
    }

}(jQuery));
